import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0fcc4b9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mqr" }
const _hoisted_2 = { class: "mqr__modal" }
const _hoisted_3 = { class: "mqr__modal-close" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mqr__modal-title" }, "QR код", -1))
const _hoisted_5 = { class: "mqr__modal-qrcode" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "mqr__modal-qrcode-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconClose = _resolveComponent("IconClose")!
  const _component_EllipsisLoader = _resolveComponent("EllipsisLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
      class: "mqr__overlay"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconClose, {
          onClick: _ctx.onClose,
          class: "mqr__modal-close-icon"
        }, null, 8, ["onClick"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isShowQrCode)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "mqr__modal-qrcode-img",
              src: _ctx.qrCodePngBase64
            }, null, 8, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_EllipsisLoader, { color: "rgb(235, 255, 82)" })
            ]))
      ]),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
        class: "mqr__modal-wrap-cancel"
      }, "Отмена")
    ])
  ]))
}